import type { SalesOverview, SalesOverviewResponseDto, SalesPerformance, SalesPerformanceResponseDto } from '@/types/sales-performance.types';

function toOverview(dto: SalesOverviewResponseDto): SalesOverview {
  const { unknownIntent, ...overview } = dto;
  return { ...overview, withoutIntent: overview.withoutIntent + unknownIntent };
}

export class SalesPerformanceAdapter {
  static fromApi(dto: SalesPerformanceResponseDto): SalesPerformance {
    if (!dto || !Array.isArray(dto.conversationFunnel) || !Array.isArray(dto.nudgeFunnel) || !dto.overview || !dto.previous) {
      throw new Error('Sales performance response is unavailable');
    }
    return {
      ...dto,
      overview: toOverview(dto.overview),
      previous: toOverview(dto.previous),
      conversationFunnel: dto.conversationFunnel.map((stage, index) => index === 1
        ? { ...stage, label: 'Buying intent', dropOffLabel: 'No intent' }
        : stage),
      products: dto.products.map((product) => ({ ...product, title: product.title || product.handle })),
      revenueOverTime: [...dto.revenueOverTime].sort((a, b) => a.date.localeCompare(b.date)),
    };
  }
}
